import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemImportExternalRoute: InvariantJiraRoute = {
	name: 'global-settings-system-import-external',
	path: '/secure/admin/ExternalImport1.jspa',
};
